import styled from '@emotion/styled';

export const RaceCardSection = styled('section', { label: 'RaceCardSection' })`
    flex: 1 1 0%;
    display: flex;
    flex-flow: column nowrap;
    flex-wrap: nowrap;
`;

